import { render } from "./BlockViewer.vue?vue&type=template&id=31081ba6&scoped=true"
import script from "./BlockViewer.vue?vue&type=script&lang=js"
export * from "./BlockViewer.vue?vue&type=script&lang=js"

import "./BlockViewer.vue?vue&type=style&index=0&id=31081ba6&scoped=true&lang=scss"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-31081ba6"],['__file',"src/infrastructure/templates/prime/apollo/components/BlockViewer.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "31081ba6"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('31081ba6', __exports__)) {
    api.reload('31081ba6', __exports__)
  }
  
  module.hot.accept("./BlockViewer.vue?vue&type=template&id=31081ba6&scoped=true", () => {
    api.rerender('31081ba6', render)
  })

}


export default __exports__